import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 34BD0C0B-AF54-4BFC-A539-35D67612C4AC
 * name arrow-down-drop-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-drop-circle.svg
 * tags
 * - Arrow 
 */
export const ArrowDownDropCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M7,10L12,15L17,10H7Z" /></>, 'ArrowDownDropCircleIcon');
export default ArrowDownDropCircleIcon